import {
    CartAuthContext,
    defineCartAuthFeature,
} from 'modules/Cart/contexts/cartAuthContext';
import {CartContext} from 'modules/Cart/contexts/cartContext';
import {useCartState} from 'modules/Cart/hooks/useCartState';
import {FC, useMemo} from 'react';
import {Outlet} from 'react-router';

import styles from './CartLayout.module.css';

export const CART_LAYOUT_ELEMENT_ID = 'CART_LAYOUT_ELEMENT_ID';

type Props = {};
export const CartLayout: FC<Props> = () => {
    const contextValue = useCartState();

    const authContextValue = useMemo(() => {
        const withAuth = defineCartAuthFeature();
        return {
            withAuth,
        };
    }, []);

    return (
        <CartAuthContext.Provider value={authContextValue}>
            <CartContext.Provider value={contextValue}>
                <div className={styles.block} id={CART_LAYOUT_ELEMENT_ID}>
                    <div className={styles.container}>
                        <Outlet />
                    </div>
                </div>
            </CartContext.Provider>
        </CartAuthContext.Provider>
    );
};
